import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/mikado/mikado/website/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["TermsPage"] */ "/home/runner/work/mikado/mikado/website/src/components/pages/TermsPage.tsx");
